import React, { useContext } from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
import { TrackContext } from '../context/AnalyticsContext';

const withMouseDown = (
  ComponentToWrap: any,
  buttonName?: string,
  buttonType?:
    | 'cta'
    | 'copy'
    | 'navigation'
    | 'filter'
    | 'open modal'
    | 'close modal'
    | 'selection'
    | 'resize element'
    | 'alter component'
    | 'toggle'
    | 'dropdown',
  buttonCopy?: string
) => {
  const WithMouseDownComponent = (props) => {
    const { track } = useAnalytics();
    const prevProps = useContext(TrackContext);
    const handleTrack = () => {
      track('button_clicked', {
        ...prevProps,
        button_copy: buttonCopy ?? undefined,
        button_name: buttonName,
        button_type: buttonType,
      });
    };

    return <ComponentToWrap onMouseDown={handleTrack} {...props} />;
  };

  const WithMouseDownWrapper = (props) => <WithMouseDownComponent {...props} />;

  WithMouseDownWrapper.displayName = 'withMouseDownWrapper';
  return WithMouseDownWrapper;
};

export default withMouseDown;
